<template>
    <div>
        <shop-dialog-selector
            v-model="dialogVisible"
            :multiple="multiple"
            :allShopButtonVisible="allShopButtonVisible"
            :allRetailStoresVisible="allRetailStoresVisible"
            :isReturnShortcutValue="isReturnShortcutValue"
            :title="title"
            :loading="dialogLoading"
            :group-data="selectorData"
            :sidebar-list="sidebarData"
            :before-confirm="beforeConfirm"
            :disabled-select-child-fun="disabledSelectChildFun"
            :default-checked-keys="defaultCheckedKeys"
            @on-confirm="onConfirm"
            @on-select-item="onSelectItem">
        </shop-dialog-selector>
    </div>
</template>
<script>
import UtilsMixins from '@/mixins/utils'
import ShopDialogSelector from './shop-dialog-selector.vue'
export default {
    name: 'shopDialogSelectorInstance',
    mixins: [UtilsMixins],
    components: {
        ShopDialogSelector,
    },
    data() {
        return {
            dialogLoading: false,
            defaultCheckedKeys: [],
            hasTenant: false,
            dialogVisible: false,
            rankingMode: false,
            selectorData: null,
            sidebarData: null,
            multiple: true,
            title: undefined,
            allShopButtonVisible: true,
            allRetailStoresVisible: true,
            isReturnShortcutValue: true,
            beforeConfirm: undefined,
            disabledSelectChildFun: undefined,
        }
    },
    methods: {
        show(params) {
            const { hasTenant, filterNode, loadData, defaultCheckedKeys, multiple, allShopButtonVisible, allRetailStoresVisible, isReturnShortcutValue, title, beforeConfirm, disabledSelectChildFun } = params;
            if (multiple !== undefined) {
                this.multiple = multiple;
            }
            this.title = title || '请选择门店';
            if(allRetailStoresVisible !== undefined) {
                this.allRetailStoresVisible = allRetailStoresVisible;
            }
            if (allShopButtonVisible !== undefined) {
                this.allShopButtonVisible = allShopButtonVisible;
            }
            if (isReturnShortcutValue !== undefined) {
                this.isReturnShortcutValue = isReturnShortcutValue;
            }
            this.beforeConfirm = beforeConfirm;
            this.disabledSelectChildFun = disabledSelectChildFun;
            this.hasTenant = hasTenant;
            this.filterNode = filterNode;
            this.defaultCheckedKeys = defaultCheckedKeys;
            if (loadData) {
                this.dialogLoading = true;
                loadData(this.loadDataCallback);
            }
            this.dialogVisible = true;
        },
        onConfirm(data, shortcutValue) {
            this.resolve({
                selectValue: data,
                shortcutValue,
            });
        },
        onSelectItem(data) {
            this.resolve(data);
        },
        loadDataCallback(listData) {
            let { children: contentData, name, id } = listData;
            const tenantShopData = {
                name,
                id,
                softgenre: 0,
                viewName: name,
                areaId: 999999,
            }
            const tenantGroupData = {
                name: '总部',
                viewName: '总部',
                id: 999999,
                children: [ tenantShopData ]
            }
            contentData.filter(item => item.children && item.children.length).forEach(areaData => {
                const { name, children } = areaData;
                areaData.viewName = name;
                areaData.children = children.map(shopData => {
                    shopData.viewName = this.getShopNameByData(shopData)
                    return shopData;
                })
                if (this.filterNode) {
                    areaData.children = areaData.children.filter(item => this.filterNode(item));
                }
            })
            contentData = contentData.sort((a, b) => { return (b.id - a.id) });
            const otherIndex = contentData.findIndex(item => item.name === '全部');
            if (otherIndex !== -1) {
                contentData[otherIndex].viewName = contentData.length > 1 ? '其他' : '门店';
            }
            if (this.hasTenant) {
				const hasTenant = contentData.some(item => item.id === tenantGroupData.id);
				if (!hasTenant) {
					contentData.unshift(tenantGroupData);
				}
			}else {
                contentData = contentData.filter(item => item.id != tenantGroupData.id);
            }
            this.selectorData = contentData;
            this.sidebarData = contentData;
            this.dialogLoading = false;
        },
    },

}
</script>